const address_ajax_object = {};
let last_search = null;
function autocomplete_address(sender) {
    const $ = jQuery.noConflict();
    const elm = $(sender);
    const find_parent = function(elm) {
        //look for the city element which will be on a new .row, if you have that, you have the right parent
        if(elm.parent().find('#city').length > 0 || elm.parent().find('[name*=city\\]]').length > 0) {
            return elm.parent();
        } else {
            return find_parent(elm.parent());
        }
    };
    const parent = find_parent(elm);
    const pc = parent.find('input[name*=postal_code]');
    const postal_code = pc.val();
    if(postal_code.split(' ').length > 1) {
        pc.val(postal_code.split(' ').join(''));
    }
    const sn = parent.find('input[name*=street_no]');
    const street_number = sn.val();
    const validate_elm = function(arg, type) {
        arg = arg.replace(new RegExp(" ", 'g'), '');
        let test = false;
        if(type === 'postal_code') {
            const numbers = arg.substr(0,4);
            const letters = arg.substr(4);
            test = (!isNaN(numbers) && isNaN(letters));
        } else {
            test = !isNaN(arg) && arg > 0;
        }
        const label = parent.find('label[for='+type+']');
        const input = parent.find('input[name*='+type+'\\]]');
        if(test === true) {
            label.removeClass('is-invalid-label');
            input.removeClass('is-invalid-input');
        } else {
            label.addClass('is-invalid-label');
            input.addClass('is-invalid-input');
        }
        return test;
    };
    const this_search = postal_code+'_'+street_number;

    if(validate_elm(postal_code,'postal_code') && validate_elm(street_number, 'street_no') && this_search !== last_search) {
        let uid = elm.attr('data-ajax-uid');
        if(uid === undefined) {
            const get_unique_ajax_uid = function() {
                const uid = get_unique_id();
                if(address_ajax_object[uid]) {
                    return get_unique_ajax_uid();
                }
                return uid;
            };
            uid = get_unique_ajax_uid();

            pc.attr('data-ajax-uid',uid);
            sn.attr('data-ajax-uid',uid);
        }

        const current_ajax_object = address_ajax_object[uid];
        if(current_ajax_object !== false && current_ajax_object !== undefined) {
            current_ajax_object.abort();
        }
        const input_array = [
            parent.find(':input[name*=city\\]]'),
            parent.find(':input[name*=country\\]]'),
            parent.find(':input[name*=street\\]]'),
        ];
        $.each(input_array, function(key, input) {
            input.attr('disabled', 'disabled');
        });
        parent.isLoading();
        address_ajax_object[uid] = $.ajax({
            url: '/ajax/getAddressData',
            dataType: 'JSON',
            data: {postal_code:postal_code, street_number: street_number},
            success: function(answer) {
                parent.doneLoading();
                $.each(input_array, function(key, input) {
                   input.removeAttr('disabled');
                });
                $.each(answer, function(key, value) {
                    if(value == null) {
                        value = '';
                    }
                    if(value.length > 0) {
                        parent.find(':input[name*='+key+'\\]]').val(value);
                    }
                });
                last_search = this_search;
            }, error: function(a,b,c) {
                parent.doneLoading();
                $.each(input_array, function(key, input) {
                    input.removeAttr('disabled');
                });
            }.bind([input_array])
        });
    }
}

function fill_the_address(elm) {
    const $ = jQuery.noConflict();
    const select = $(elm);
    const container = select.parents('.row').parent();
    const v = select.val();

    const fields = ['postal_code', 'street_no', 'street_no_adding', 'street', 'city', 'country_code'];
    let data = {};
    if(v > 0) {
        data = JSON.parse(select.find('option[value='+v+']').attr('data-value'));
    }

    $.each(fields, function(key, field_name) {
        const input = container.find(':input[name*='+field_name+'\\]]');

        if(v < 1) {
            input.val('');
        } else {
            input.val(data[field_name]);
        }
    });
}

function choose_this_address(sender) {
    const $ = jQuery.noConflict();
    const elm = $(sender);

    const v = elm.val();
    const data = JSON.parse(v);

    if (data === undefined || data === null) {
        return;
    }
    const container = elm.parents('.row:first').parent();

    const fields = ['postal_code', 'street_no', 'street_no_adding', 'street', 'city', 'country_code', 'id', 'type'];

    $.each(fields, function(key, field_name) {
        const input = container.find(':input[name*='+field_name+'\\]]');
        const isSelect = input.prop('tagName') === 'SELECT';
        if (isSelect) {
            input.find('option[selected]').removeAttr('selected');
        }
        if(v < 1) {
            if (field_name === 'country_code') {
                input.find('option[value="NL"]').attr('selected', 'selected');
                input.val('NL');
            } else {
                input.val('');
            }
        } else if(data !== null && data[field_name] !== undefined) {
            input.val(data[field_name]);
            if (isSelect) {
                const option = input.find('option[value="' + data[field_name] + '"]');
                if (option.length > 0) {
                    option.attr('selected', 'selected');
                } else {
                    if (field_name === 'country_code') {
                        input.val('NL');
                    } else {
                        input.val('');
                    }
                }
            }
        }
    });
    if(container.find('input[name*="name"]').length > 0) {
        container.find('input[name*="name"]').val(data.name);
    }
}